/* tslint:disable */
/* eslint-disable */
/**
 * grpc/properties/service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { PropertiesApplyDraftRowsResponse } from '../models'
// @ts-ignore
import { PropertiesApplyUnitImagesToLayoutResponse } from '../models'
// @ts-ignore
import { PropertiesAssignImportImageResponse } from '../models'
// @ts-ignore
import { PropertiesBulkUpsertUnitsResponse } from '../models'
// @ts-ignore
import { PropertiesCleanupImportImagesResponse } from '../models'
// @ts-ignore
import { PropertiesCreateCityRequest } from '../models'
// @ts-ignore
import { PropertiesCreateCityResponse } from '../models'
// @ts-ignore
import { PropertiesCreateDeveloperRequest } from '../models'
// @ts-ignore
import { PropertiesCreateDeveloperResponse } from '../models'
// @ts-ignore
import { PropertiesCreateImportDraftRequest } from '../models'
// @ts-ignore
import { PropertiesCreateImportDraftResponse } from '../models'
// @ts-ignore
import { PropertiesCreateObjectRequest } from '../models'
// @ts-ignore
import { PropertiesCreateObjectResponse } from '../models'
// @ts-ignore
import { PropertiesCreateResidentialComplexBlockResponse } from '../models'
// @ts-ignore
import { PropertiesCreateResidentialComplexMaterialResponse } from '../models'
// @ts-ignore
import { PropertiesCreateResidentialComplexRequest } from '../models'
// @ts-ignore
import { PropertiesCreateResidentialComplexResponse } from '../models'
// @ts-ignore
import { PropertiesCreateUnitResponse } from '../models'
// @ts-ignore
import { PropertiesDashboardMetricsResponse } from '../models'
// @ts-ignore
import { PropertiesGeneratePresentationResponse } from '../models'
// @ts-ignore
import { PropertiesGetCitiesResponse } from '../models'
// @ts-ignore
import { PropertiesGetImportDraftResponse } from '../models'
// @ts-ignore
import { PropertiesGetLocationPageDataResponse } from '../models'
// @ts-ignore
import { PropertiesGetResidentialComplexFilterValuesResponse } from '../models'
// @ts-ignore
import { PropertiesGetSEODataResponse } from '../models'
// @ts-ignore
import { PropertiesGetUnitsSummaryResponse } from '../models'
// @ts-ignore
import { PropertiesListCitiesAdminResponse } from '../models'
// @ts-ignore
import { PropertiesListImportDraftsResponse } from '../models'
// @ts-ignore
import { PropertiesListImportImagesResponse } from '../models'
// @ts-ignore
import { PropertiesListPaymentPlansResponse } from '../models'
// @ts-ignore
import { PropertiesListResidentialComplexBlocksResponse } from '../models'
// @ts-ignore
import { PropertiesListResidentialComplexMaterialsResponse } from '../models'
// @ts-ignore
import { PropertiesListUnitMixResponse } from '../models'
// @ts-ignore
import { PropertiesListUnitsResponse } from '../models'
// @ts-ignore
import { PropertiesPreviewImportDraftShowcaseResponse } from '../models'
// @ts-ignore
import { PropertiesReadCityAdminResponse } from '../models'
// @ts-ignore
import { PropertiesReadDeveloperAdminResponse } from '../models'
// @ts-ignore
import { PropertiesReadDeveloperResponse } from '../models'
// @ts-ignore
import { PropertiesReadObjectResponse } from '../models'
// @ts-ignore
import { PropertiesReadResidentialComplexAdminResponse } from '../models'
// @ts-ignore
import { PropertiesReadResidentialComplexResponse } from '../models'
// @ts-ignore
import { PropertiesReplaceObjectImagesResponse } from '../models'
// @ts-ignore
import { PropertiesReplacePaymentPlansResponse } from '../models'
// @ts-ignore
import { PropertiesReplaceUnitImagesResponse } from '../models'
// @ts-ignore
import { PropertiesReplaceUnitMixResponse } from '../models'
// @ts-ignore
import { PropertiesSearchAdminResidentialComplexesResponse } from '../models'
// @ts-ignore
import { PropertiesSearchDevelopersRequest } from '../models'
// @ts-ignore
import { PropertiesSearchDevelopersResponse } from '../models'
// @ts-ignore
import { PropertiesSearchObjectsRequest } from '../models'
// @ts-ignore
import { PropertiesSearchObjectsResponse } from '../models'
// @ts-ignore
import { PropertiesSearchResidentialComplexesRequest } from '../models'
// @ts-ignore
import { PropertiesSearchResidentialComplexesResponse } from '../models'
// @ts-ignore
import { PropertiesServiceApplyDraftRowsBody } from '../models'
// @ts-ignore
import { PropertiesServiceAssignImportImageBody } from '../models'
// @ts-ignore
import { PropertiesServiceBulkUpsertUnitsBody } from '../models'
// @ts-ignore
import { PropertiesServiceCreateResidentialComplexBlockBody } from '../models'
// @ts-ignore
import { PropertiesServiceCreateResidentialComplexMaterialBody } from '../models'
// @ts-ignore
import { PropertiesServiceCreateUnitBody } from '../models'
// @ts-ignore
import { PropertiesServicePreviewImportDraftShowcaseBody } from '../models'
// @ts-ignore
import { PropertiesServiceReplaceObjectImagesBody } from '../models'
// @ts-ignore
import { PropertiesServiceReplacePaymentPlansBody } from '../models'
// @ts-ignore
import { PropertiesServiceReplaceUnitImagesBody } from '../models'
// @ts-ignore
import { PropertiesServiceReplaceUnitMixBody } from '../models'
// @ts-ignore
import { PropertiesServiceSetDraftResidentialComplexBody } from '../models'
// @ts-ignore
import { PropertiesServiceSetResidentialComplexCommissionBody } from '../models'
// @ts-ignore
import { PropertiesServiceSetResidentialComplexSalesStartBody } from '../models'
// @ts-ignore
import { PropertiesServiceUpdateCityBody } from '../models'
// @ts-ignore
import { PropertiesServiceUpdateDraftRowBody } from '../models'
// @ts-ignore
import { PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody } from '../models'
// @ts-ignore
import { PropertiesServiceUpdateResidentialComplexBlockBody } from '../models'
// @ts-ignore
import { PropertiesServiceUpdateUnitBody } from '../models'
// @ts-ignore
import { PropertiesSetDraftResidentialComplexResponse } from '../models'
// @ts-ignore
import { PropertiesSetResidentialComplexCommissionResponse } from '../models'
// @ts-ignore
import { PropertiesSetResidentialComplexSalesStartResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateCityResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateDeveloperRequest } from '../models'
// @ts-ignore
import { PropertiesUpdateDeveloperResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateDraftRowResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateObjectRequest } from '../models'
// @ts-ignore
import { PropertiesUpdateObjectResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateResidentialComplexAgentsAvailabilityResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateResidentialComplexBlockResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateResidentialComplexRequest } from '../models'
// @ts-ignore
import { PropertiesUpdateResidentialComplexResponse } from '../models'
// @ts-ignore
import { PropertiesUpdateUnitResponse } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
/**
 * PropertiesServiceApi - axios parameter creator
 * @export
 */
export const PropertiesServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Applies the selected rows of a draft to the project in a single transaction, matching existing units by code. Rows left unselected stay in the draft.
     * @param {string} id
     * @param {PropertiesServiceApplyDraftRowsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceApplyDraftRows: async (
      id: string,
      body: PropertiesServiceApplyDraftRowsBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceApplyDraftRows', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceApplyDraftRows', 'body', body)
      const localVarPath = `/api/v1/properties/unit-import-drafts/{id}/apply`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: a price list brings hundreds of units and a handful of layouts — attaching plans one by one is not a thing anyone would do (DEV-1817).
     * @summary Copies the pictures of a unit to every other unit of the project sharing its layout code. Only the references are copied, not the files.
     * @param {string} unitId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceApplyUnitImagesToLayout: async (
      unitId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'unitId' is not null or undefined
      assertParamExists('propertiesServiceApplyUnitImagesToLayout', 'unitId', unitId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceApplyUnitImagesToLayout', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/units/{unitId}/images/apply-to-layout`.replace(
          `{${'unitId'}}`,
          encodeURIComponent(String(unitId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Accepts a staged image: it moves from the private staging bucket into the public one and becomes an ordinary project image of the chosen type.
     * @param {string} id
     * @param {PropertiesServiceAssignImportImageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceAssignImportImage: async (
      id: string,
      body: PropertiesServiceAssignImportImageBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceAssignImportImage', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceAssignImportImage', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/import-images/{id}/assign`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates or updates many units at once, matching them by unit code within the project. This is how an approved price list becomes inventory.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceBulkUpsertUnitsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceBulkUpsertUnits: async (
      residentialComplexId: string,
      body: PropertiesServiceBulkUpsertUnitsBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceBulkUpsertUnits',
        'residentialComplexId',
        residentialComplexId,
      )
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceBulkUpsertUnits', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/units/bulk-upsert`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Drops every staged image that was never assigned. Called when a project is published, so that unused imports do not linger in the bucket.
     * @param {string} residentialComplexId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCleanupImportImages: async (
      residentialComplexId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceCleanupImportImages',
        'residentialComplexId',
        residentialComplexId,
      )
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCleanupImportImages', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/import-images/cleanup`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a city to the reference book.
     * @param {PropertiesCreateCityRequest} body Details of a new city.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateCity: async (
      body: PropertiesCreateCityRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateCity', 'body', body)
      const localVarPath = `/api/v1/properties/admin/cities`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Registers a developer. The company becomes selectable as the owner of a residential complex.
     * @param {PropertiesCreateDeveloperRequest} body Details of a new developer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateDeveloper: async (
      body: PropertiesCreateDeveloperRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateDeveloper', 'body', body)
      const localVarPath = `/api/v1/properties/developer`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: drafts back the CRM import wizard, are gated on properties permissions and never reach the public site (DEV-1078).
     * @summary Starts an import draft from an uploaded price list: rows are parsed and held for review before anything touches live inventory.
     * @param {PropertiesCreateImportDraftRequest} body A parsed price list to hold for review.  Internal note: rows come from the harvester response and the CRM front end orchestrates the flow (DEV-1078, DEV-1081).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateImportDraft: async (
      body: PropertiesCreateImportDraftRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateImportDraft', 'body', body)
      const localVarPath = `/api/v1/properties/unit-import-drafts`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a standalone listing — a property sold on its own rather than as part of a project.
     * @param {PropertiesCreateObjectRequest} body Details of a new listing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateObject: async (
      body: PropertiesCreateObjectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateObject', 'body', body)
      const localVarPath = `/api/v1/properties/object`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Creates a residential complex (a project). It stays invisible on the public site until its visibility is switched on.
     * @param {PropertiesCreateResidentialComplexRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateResidentialComplex: async (
      body: PropertiesCreateResidentialComplexRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateResidentialComplex', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complex`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: blocks and units back the CRM project constructor and are gated on properties permissions; units never appear in public responses (DEV-1077, ADR-0035). The literal routes below (.../blocks/{id}) are declared after DeleteResidentialComplex on purpose — grpc-gateway matches in declaration order, and the {id} pattern would otherwise swallow them.
     * @summary Adds a block (building) to a project.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceCreateResidentialComplexBlockBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateResidentialComplexBlock: async (
      residentialComplexId: string,
      body: PropertiesServiceCreateResidentialComplexBlockBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceCreateResidentialComplexBlock',
        'residentialComplexId',
        residentialComplexId,
      )
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateResidentialComplexBlock', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/blocks`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: materials live in a private bucket and are served through presigned links; the whole group is gated on properties permissions (DEV-1021).
     * @summary Attaches a marketing material (brochure, price list, floor plan) to a project.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceCreateResidentialComplexMaterialBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateResidentialComplexMaterial: async (
      residentialComplexId: string,
      body: PropertiesServiceCreateResidentialComplexMaterialBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceCreateResidentialComplexMaterial',
        'residentialComplexId',
        residentialComplexId,
      )
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateResidentialComplexMaterial', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/materials`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Adds a single unit (apartment) to a project.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceCreateUnitBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateUnit: async (
      residentialComplexId: string,
      body: PropertiesServiceCreateUnitBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists('propertiesServiceCreateUnit', 'residentialComplexId', residentialComplexId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceCreateUnit', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/units`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a city. Refused while content still references it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteCity: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteCity', 'id', id)
      const localVarPath = `/api/v1/properties/admin/cities/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Soft-deletes a developer. Residential complexes already linked to it keep the reference and stay readable.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteDeveloper: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteDeveloper', 'id', id)
      const localVarPath = `/api/v1/properties/developer/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Discards a staged image together with its file.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteImportImage: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteImportImage', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/import-images/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Soft-deletes a standalone listing. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteObject: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteObject', 'id', id)
      const localVarPath = `/api/v1/properties/object/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Soft-deletes a residential complex together with its blocks and units.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteResidentialComplex: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteResidentialComplex', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a block together with the units inside it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteResidentialComplexBlock: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteResidentialComplexBlock', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/blocks/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Removes a marketing material and its stored file.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteResidentialComplexMaterial: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteResidentialComplexMaterial', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/materials/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Deletes a unit.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteUnit: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDeleteUnit', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/units/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Throws a draft away without touching inventory.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDiscardDraft: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceDiscardDraft', 'id', id)
      const localVarPath = `/api/v1/properties/unit-import-drafts/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Builds a PDF presentation of a project and returns a link to it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGeneratePresentation: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceGeneratePresentation', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/{id}/presentation`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the cities of the reference book for navigation, filters and the city hub, named in the language of the request.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {boolean} [withGuideOnly] Keep only the cities whose guide has text. Off by default: navigation and filters list every city, the city hub lists the ones worth linking to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetCities: async (
      paginationPage?: string,
      paginationPerPage?: string,
      withGuideOnly?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/cities`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (withGuideOnly !== undefined) {
        localVarQueryParameter['withGuideOnly'] = withGuideOnly
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns catalog counters for the CRM dashboard: how many projects, listings and developers exist, and how many of them are published.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetDashboardMetrics: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/dashboard-metrics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one import draft with all parsed rows and their validation errors.
     * @param {string} id
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetImportDraft: async (
      id: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceGetImportDraft', 'id', id)
      const localVarPath = `/api/v1/properties/unit-import-drafts/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns everything a city landing page needs: description, statistics and the intro and outro texts shown above and below the listing grid.
     * @param {string} citySlug
     * @param {string} [locale] Locale code (ru, en, vn). An empty value falls back to Russian, so REST callers may omit it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetLocationPageData: async (
      citySlug: string,
      locale?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'citySlug' is not null or undefined
      assertParamExists('propertiesServiceGetLocationPageData', 'citySlug', citySlug)
      const localVarPath = `/api/v1/properties/locations/{citySlug}`.replace(
        `{${'citySlug'}}`,
        encodeURIComponent(String(citySlug)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (locale !== undefined) {
        localVarQueryParameter['locale'] = locale
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the value ranges and option lists behind the project search filters — price bounds, room counts, amenities actually in use. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetResidentialComplexFilterValues: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/residential-complex-filter-values`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the catalog data a sitemap generator needs: slugs and last modification dates of every published entity. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetSEOData: async (
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/seo-data`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Counts the units of a project by sale status in one call, so the CRM tab does not have to list them once per tile.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetUnitsSummary: async (
      residentialComplexId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceGetUnitsSummary',
        'residentialComplexId',
        residentialComplexId,
      )
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/units/summary`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns every published residential complex without pagination. Intended for sitemap and export jobs, not for interactive listings. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListAllResidentialComplexes: async (
      body: PropertiesSearchResidentialComplexesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceListAllResidentialComplexes', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complexes/all`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists every city in the reference book, including those with no published content yet.
     * @param {boolean} [includeDeleted] Include cities that were deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListCitiesAdmin: async (
      includeDeleted?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/admin/cities`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (includeDeleted !== undefined) {
        localVarQueryParameter['includeDeleted'] = includeDeleted
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists import drafts with their review state.
     * @param {string} [residentialComplexId]
     * @param {Array<PropertiesServiceListImportDraftsStatusEnum>} [status] Keep drafts in any of these states.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListImportDrafts: async (
      residentialComplexId?: string,
      status?: Array<PropertiesServiceListImportDraftsStatusEnum>,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/properties/unit-import-drafts`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (residentialComplexId !== undefined) {
        localVarQueryParameter['residentialComplexId'] = residentialComplexId
      }

      if (status) {
        localVarQueryParameter['status'] = status
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists staged import images awaiting a decision.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListImportImages: async (
      residentialComplexId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceListImportImages',
        'residentialComplexId',
        residentialComplexId,
      )
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/import-images`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns the payment plans offered for a project: instalment schedules and the discounts attached to them.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListPaymentPlans: async (
      residentialComplexId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceListPaymentPlans',
        'residentialComplexId',
        residentialComplexId,
      )
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/payment-plans`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the blocks of a project.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListResidentialComplexBlocks: async (
      residentialComplexId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceListResidentialComplexBlocks',
        'residentialComplexId',
        residentialComplexId,
      )
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/blocks`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the marketing materials of a project with short-lived download links. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListResidentialComplexMaterials: async (
      residentialComplexId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceListResidentialComplexMaterials',
        'residentialComplexId',
        residentialComplexId,
      )
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/materials`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: sales data, not public listing content — prices here are never exposed on the public site (DEV-1159, ADR-0038).
     * @summary Returns the unit mix of a project: how many units of each layout it has, in what area range and at what price.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListUnitMix: async (
      residentialComplexId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceListUnitMix',
        'residentialComplexId',
        residentialComplexId,
      )
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/unit-mix`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Lists the units of a project, optionally filtered by block, floor or availability.
     * @param {string} residentialComplexId
     * @param {string} [filterBlockId]
     * @param {Array<PropertiesServiceListUnitsFilterStatusEnum>} [filterStatus] Keep units in any of these states.
     * @param {Array<string>} [filterNumberOfRooms]
     * @param {string} [filterFloor]
     * @param {Array<PropertiesServiceListUnitsFilterObjectTypeEnum>} [filterObjectType] Keep units of any of these types. OBJECT_TYPE_INVALID is a meaningful value here and means \&quot;type is not set\&quot;: such units are excluded from the showcase recompute, so the constructor needs a way to list them.   - OBJECT_TYPE_CONDOTEL: Hotel-style apartment sold to a private owner and operated as a hotel room.  - OBJECT_TYPE_SHOPHOUSE: Ground-floor retail with living space above.
     * @param {string} [filterUpdatedBefore] Keep units untouched since this moment. Set to the time the last price list was applied, it lists the units that file did not mention: they are most likely sold, yet still count towards the showcase (DEV-1219).
     * @param {string} [filterCode] Keep units whose code contains this substring, case-insensitively. A unit code is an identifier, not prose (\&quot;A1-05-02\&quot;), so full-text search is the wrong tool here: to_tsvector splits it on the dashes and a search for \&quot;05\&quot; finds nothing. The match always runs inside one project, which caps the scan at the roughly thousand units a project has.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListUnits: async (
      residentialComplexId: string,
      filterBlockId?: string,
      filterStatus?: Array<PropertiesServiceListUnitsFilterStatusEnum>,
      filterNumberOfRooms?: Array<string>,
      filterFloor?: string,
      filterObjectType?: Array<PropertiesServiceListUnitsFilterObjectTypeEnum>,
      filterUpdatedBefore?: string,
      filterCode?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists('propertiesServiceListUnits', 'residentialComplexId', residentialComplexId)
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/units`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (filterBlockId !== undefined) {
        localVarQueryParameter['filter.blockId'] = filterBlockId
      }

      if (filterStatus) {
        localVarQueryParameter['filter.status'] = filterStatus
      }

      if (filterNumberOfRooms) {
        localVarQueryParameter['filter.numberOfRooms'] = filterNumberOfRooms
      }

      if (filterFloor !== undefined) {
        localVarQueryParameter['filter.floor'] = filterFloor
      }

      if (filterObjectType) {
        localVarQueryParameter['filter.objectType'] = filterObjectType
      }

      if (filterUpdatedBefore !== undefined) {
        localVarQueryParameter['filter.updatedBefore'] =
          (filterUpdatedBefore as any) instanceof Date
            ? (filterUpdatedBefore as any).toISOString()
            : filterUpdatedBefore
      }

      if (filterCode !== undefined) {
        localVarQueryParameter['filter.code'] = filterCode
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: computed for real — the rows are applied and the showcase recomputed inside a transaction that is then rolled back, so the preview cannot drift away from what apply actually does (DEV-1816). Holds the same locks as apply, so it is a one-off answer, not something to poll.
     * @summary Shows what applying the selected rows would do to the listings of the project: the listings as they are now, and as they would be afterwards.
     * @param {string} id
     * @param {PropertiesServicePreviewImportDraftShowcaseBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServicePreviewImportDraftShowcase: async (
      id: string,
      body: PropertiesServicePreviewImportDraftShowcaseBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServicePreviewImportDraftShowcase', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServicePreviewImportDraftShowcase', 'body', body)
      const localVarPath = `/api/v1/properties/unit-import-drafts/{id}/showcase-preview`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns one city with its full reference data and page texts.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadCityAdmin: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadCityAdmin', 'id', id)
      const localVarPath = `/api/v1/properties/admin/cities/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns a developer as shown on the public site.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadDeveloper: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadDeveloper', 'id', id)
      const localVarPath = `/api/v1/properties/developer/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns a developer with the fields the public view omits: moderation state, internal notes, unpublished media.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadDeveloperForAdmin: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadDeveloperForAdmin', 'id', id)
      const localVarPath = `/api/v1/properties/admin/developer/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns a standalone listing by id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadObject: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadObject', 'id', id)
      const localVarPath = `/api/v1/properties/object/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns a residential complex by id, as shown on the public site.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplex: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadResidentialComplex', 'id', id)
      const localVarPath = `/api/v1/properties/residential-complex/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns a residential complex by its city and project slug — the pair that forms the public URL.
     * @param {string} citySlug
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplexBySlug: async (
      citySlug: string,
      slug: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'citySlug' is not null or undefined
      assertParamExists('propertiesServiceReadResidentialComplexBySlug', 'citySlug', citySlug)
      // verify required parameter 'slug' is not null or undefined
      assertParamExists('propertiesServiceReadResidentialComplexBySlug', 'slug', slug)
      const localVarPath = `/api/v1/properties/rc/{citySlug}/{slug}`
        .replace(`{${'citySlug'}}`, encodeURIComponent(String(citySlug)))
        .replace(`{${'slug'}}`, encodeURIComponent(String(slug)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Returns a residential complex with the fields the public view omits: moderation state, sales data, unpublished media.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplexForAdmin: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceReadResidentialComplexForAdmin', 'id', id)
      const localVarPath = `/api/v1/properties/admin/residential-complex/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: allowed even when the listings are recomputed from units — the gate covers the numbers of a row, not its gallery. An empty list clears the set, and the listing falls back to the pictures of its units (DEV-1817).
     * @summary Replaces the pictures of a listing: floor plans and finishing options.
     * @param {string} objectId
     * @param {PropertiesServiceReplaceObjectImagesBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReplaceObjectImages: async (
      objectId: string,
      body: PropertiesServiceReplaceObjectImagesBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'objectId' is not null or undefined
      assertParamExists('propertiesServiceReplaceObjectImages', 'objectId', objectId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceReplaceObjectImages', 'body', body)
      const localVarPath = `/api/v1/properties/object/{objectId}/images`.replace(
        `{${'objectId'}}`,
        encodeURIComponent(String(objectId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Replaces the whole set of payment plans of a project in one transaction.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceReplacePaymentPlansBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReplacePaymentPlans: async (
      residentialComplexId: string,
      body: PropertiesServiceReplacePaymentPlansBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceReplacePaymentPlans',
        'residentialComplexId',
        residentialComplexId,
      )
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceReplacePaymentPlans', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/payment-plans`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Replaces the pictures of a unit.
     * @param {string} unitId
     * @param {PropertiesServiceReplaceUnitImagesBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReplaceUnitImages: async (
      unitId: string,
      body: PropertiesServiceReplaceUnitImagesBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'unitId' is not null or undefined
      assertParamExists('propertiesServiceReplaceUnitImages', 'unitId', unitId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceReplaceUnitImages', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complex/units/{unitId}/images`.replace(
        `{${'unitId'}}`,
        encodeURIComponent(String(unitId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Replaces the whole unit mix of a project in one transaction.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceReplaceUnitMixBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReplaceUnitMix: async (
      residentialComplexId: string,
      body: PropertiesServiceReplaceUnitMixBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'residentialComplexId' is not null or undefined
      assertParamExists(
        'propertiesServiceReplaceUnitMix',
        'residentialComplexId',
        residentialComplexId,
      )
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceReplaceUnitMix', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/{residentialComplexId}/unit-mix`.replace(
          `{${'residentialComplexId'}}`,
          encodeURIComponent(String(residentialComplexId)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Same search, but over every project regardless of visibility, and with the moderation fields attached.
     * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchAdminResidentialComplexes: async (
      body: PropertiesSearchResidentialComplexesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSearchAdminResidentialComplexes', 'body', body)
      const localVarPath = `/api/v1/properties/admin/residential-complexes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Searches developers by name and city with pagination.
     * @param {PropertiesSearchDevelopersRequest} body Developer search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchDevelopers: async (
      body: PropertiesSearchDevelopersRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSearchDevelopers', 'body', body)
      const localVarPath = `/api/v1/properties/developers`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Searches standalone listings by city, type, price and area.
     * @param {PropertiesSearchObjectsRequest} body Listing search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchObjects: async (
      body: PropertiesSearchObjectsRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSearchObjects', 'body', body)
      const localVarPath = `/api/v1/properties/objects`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Searches published residential complexes by city, developer, price, room count and completion date. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchResidentialComplexes: async (
      body: PropertiesSearchResidentialComplexesRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSearchResidentialComplexes', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complexes`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Points a draft at the project its rows will be applied to.
     * @param {string} id
     * @param {PropertiesServiceSetDraftResidentialComplexBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSetDraftResidentialComplex: async (
      id: string,
      body: PropertiesServiceSetDraftResidentialComplexBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceSetDraftResidentialComplex', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSetDraftResidentialComplex', 'body', body)
      const localVarPath = `/api/v1/properties/unit-import-drafts/{id}/residential-complex`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: separate from UpdateResidentialComplex because the rate is the base of every reward in a deal and is edited by a narrower circle — gated on properties:manage_commission (DEV-1873, ADR-0042). A project update leaves the rate untouched.
     * @summary Sets the commission the developer pays VINPROP for this project, together with any free-form terms.
     * @param {string} id
     * @param {PropertiesServiceSetResidentialComplexCommissionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSetResidentialComplexCommission: async (
      id: string,
      body: PropertiesServiceSetResidentialComplexCommissionBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceSetResidentialComplexCommission', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSetResidentialComplexCommission', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complex/{id}/commission`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: separate from UpdateResidentialComplex, which replaces the whole card — the project form and the Drive import would otherwise wipe the badge. Gated on properties:update (DEV-2299).
     * @summary Sets or clears the day sales of a project open. While set, the public site shows a \"sales start\" badge with that date.
     * @param {string} id
     * @param {PropertiesServiceSetResidentialComplexSalesStartBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSetResidentialComplexSalesStart: async (
      id: string,
      body: PropertiesServiceSetResidentialComplexSalesStartBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceSetResidentialComplexSalesStart', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceSetResidentialComplexSalesStart', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complex/{id}/sales-start`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Updates a city: names, slug, coordinates and landing page texts.
     * @param {string} id
     * @param {PropertiesServiceUpdateCityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateCity: async (
      id: string,
      body: PropertiesServiceUpdateCityBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceUpdateCity', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateCity', 'body', body)
      const localVarPath = `/api/v1/properties/admin/cities/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Replaces developer details. Fields left empty are cleared, not kept.
     * @param {PropertiesUpdateDeveloperRequest} body New details of an existing developer. Every field is replaced, so send the full state rather than a patch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateDeveloper: async (
      body: PropertiesUpdateDeveloperRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateDeveloper', 'body', body)
      const localVarPath = `/api/v1/properties/developer`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Saves a single edited row of a draft. Granular on purpose: reviewers edit rows one at a time, and saving the whole draft would make them race each other.
     * @param {string} id
     * @param {string} rowId
     * @param {PropertiesServiceUpdateDraftRowBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateDraftRow: async (
      id: string,
      rowId: string,
      body: PropertiesServiceUpdateDraftRowBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceUpdateDraftRow', 'id', id)
      // verify required parameter 'rowId' is not null or undefined
      assertParamExists('propertiesServiceUpdateDraftRow', 'rowId', rowId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateDraftRow', 'body', body)
      const localVarPath = `/api/v1/properties/unit-import-drafts/{id}/rows/{rowId}`
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
        .replace(`{${'rowId'}}`, encodeURIComponent(String(rowId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Replaces the details of a standalone listing.
     * @param {PropertiesUpdateObjectRequest} body New details of an existing listing. Every field is replaced.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateObject: async (
      body: PropertiesUpdateObjectRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateObject', 'body', body)
      const localVarPath = `/api/v1/properties/object`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Repeated fields are replaced wholesale: an empty list clears the previous contents rather than leaving them untouched.
     * @summary Replaces the details of a residential complex.
     * @param {PropertiesUpdateResidentialComplexRequest} body New details of an existing residential complex.  The whole record is replaced: repeated fields and translations sent empty are cleared, not preserved. buf:lint:ignore FIELD_NO_DELETE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplex: async (
      body: PropertiesUpdateResidentialComplexRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateResidentialComplex', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complex`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Internal note: gated on properties:update (DEV-1003).
     * @summary Opens or closes a single project for real estate agents, without touching its public visibility.
     * @param {string} id
     * @param {PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplexAgentsAvailability: async (
      id: string,
      body: PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceUpdateResidentialComplexAgentsAvailability', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateResidentialComplexAgentsAvailability', 'body', body)
      const localVarPath =
        `/api/v1/properties/residential-complex/{id}/agents-availability`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(id)),
        )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Renames a block or changes its floor count.
     * @param {string} id
     * @param {PropertiesServiceUpdateResidentialComplexBlockBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplexBlock: async (
      id: string,
      body: PropertiesServiceUpdateResidentialComplexBlockBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceUpdateResidentialComplexBlock', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateResidentialComplexBlock', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complex/blocks/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Updates a single unit: price, area, layout or sale status.
     * @param {string} id
     * @param {PropertiesServiceUpdateUnitBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateUnit: async (
      id: string,
      body: PropertiesServiceUpdateUnitBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('propertiesServiceUpdateUnit', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('propertiesServiceUpdateUnit', 'body', body)
      const localVarPath = `/api/v1/properties/residential-complex/units/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PropertiesServiceApi - functional programming interface
 * @export
 */
export const PropertiesServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PropertiesServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Applies the selected rows of a draft to the project in a single transaction, matching existing units by code. Rows left unselected stay in the draft.
     * @param {string} id
     * @param {PropertiesServiceApplyDraftRowsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceApplyDraftRows(
      id: string,
      body: PropertiesServiceApplyDraftRowsBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesApplyDraftRowsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceApplyDraftRows(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceApplyDraftRows']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: a price list brings hundreds of units and a handful of layouts — attaching plans one by one is not a thing anyone would do (DEV-1817).
     * @summary Copies the pictures of a unit to every other unit of the project sharing its layout code. Only the references are copied, not the files.
     * @param {string} unitId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceApplyUnitImagesToLayout(
      unitId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesApplyUnitImagesToLayoutResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceApplyUnitImagesToLayout(
          unitId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceApplyUnitImagesToLayout']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Accepts a staged image: it moves from the private staging bucket into the public one and becomes an ordinary project image of the chosen type.
     * @param {string} id
     * @param {PropertiesServiceAssignImportImageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceAssignImportImage(
      id: string,
      body: PropertiesServiceAssignImportImageBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesAssignImportImageResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceAssignImportImage(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceAssignImportImage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates or updates many units at once, matching them by unit code within the project. This is how an approved price list becomes inventory.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceBulkUpsertUnitsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceBulkUpsertUnits(
      residentialComplexId: string,
      body: PropertiesServiceBulkUpsertUnitsBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesBulkUpsertUnitsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceBulkUpsertUnits(
        residentialComplexId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceBulkUpsertUnits']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Drops every staged image that was never assigned. Called when a project is published, so that unused imports do not linger in the bucket.
     * @param {string} residentialComplexId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCleanupImportImages(
      residentialComplexId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesCleanupImportImagesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceCleanupImportImages(
          residentialComplexId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCleanupImportImages']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a city to the reference book.
     * @param {PropertiesCreateCityRequest} body Details of a new city.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateCity(
      body: PropertiesCreateCityRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesCreateCityResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceCreateCity(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateCity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Registers a developer. The company becomes selectable as the owner of a residential complex.
     * @param {PropertiesCreateDeveloperRequest} body Details of a new developer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateDeveloper(
      body: PropertiesCreateDeveloperRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesCreateDeveloperResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceCreateDeveloper(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateDeveloper']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: drafts back the CRM import wizard, are gated on properties permissions and never reach the public site (DEV-1078).
     * @summary Starts an import draft from an uploaded price list: rows are parsed and held for review before anything touches live inventory.
     * @param {PropertiesCreateImportDraftRequest} body A parsed price list to hold for review.  Internal note: rows come from the harvester response and the CRM front end orchestrates the flow (DEV-1078, DEV-1081).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateImportDraft(
      body: PropertiesCreateImportDraftRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesCreateImportDraftResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceCreateImportDraft(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateImportDraft']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates a standalone listing — a property sold on its own rather than as part of a project.
     * @param {PropertiesCreateObjectRequest} body Details of a new listing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateObject(
      body: PropertiesCreateObjectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesCreateObjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceCreateObject(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateObject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Creates a residential complex (a project). It stays invisible on the public site until its visibility is switched on.
     * @param {PropertiesCreateResidentialComplexRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateResidentialComplex(
      body: PropertiesCreateResidentialComplexRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesCreateResidentialComplexResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceCreateResidentialComplex(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateResidentialComplex']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: blocks and units back the CRM project constructor and are gated on properties permissions; units never appear in public responses (DEV-1077, ADR-0035). The literal routes below (.../blocks/{id}) are declared after DeleteResidentialComplex on purpose — grpc-gateway matches in declaration order, and the {id} pattern would otherwise swallow them.
     * @summary Adds a block (building) to a project.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceCreateResidentialComplexBlockBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateResidentialComplexBlock(
      residentialComplexId: string,
      body: PropertiesServiceCreateResidentialComplexBlockBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesCreateResidentialComplexBlockResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceCreateResidentialComplexBlock(
          residentialComplexId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateResidentialComplexBlock']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: materials live in a private bucket and are served through presigned links; the whole group is gated on properties permissions (DEV-1021).
     * @summary Attaches a marketing material (brochure, price list, floor plan) to a project.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceCreateResidentialComplexMaterialBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateResidentialComplexMaterial(
      residentialComplexId: string,
      body: PropertiesServiceCreateResidentialComplexMaterialBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesCreateResidentialComplexMaterialResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceCreateResidentialComplexMaterial(
          residentialComplexId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceCreateResidentialComplexMaterial'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Adds a single unit (apartment) to a project.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceCreateUnitBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceCreateUnit(
      residentialComplexId: string,
      body: PropertiesServiceCreateUnitBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesCreateUnitResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceCreateUnit(
        residentialComplexId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceCreateUnit']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a city. Refused while content still references it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteCity(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceDeleteCity(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteCity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Soft-deletes a developer. Residential complexes already linked to it keep the reference and stay readable.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteDeveloper(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceDeleteDeveloper(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteDeveloper']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Discards a staged image together with its file.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteImportImage(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceDeleteImportImage(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteImportImage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Soft-deletes a standalone listing. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteObject(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceDeleteObject(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteObject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Soft-deletes a residential complex together with its blocks and units.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteResidentialComplex(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceDeleteResidentialComplex(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteResidentialComplex']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a block together with the units inside it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteResidentialComplexBlock(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceDeleteResidentialComplexBlock(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteResidentialComplexBlock']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Removes a marketing material and its stored file.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteResidentialComplexMaterial(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceDeleteResidentialComplexMaterial(
          id,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceDeleteResidentialComplexMaterial'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Deletes a unit.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDeleteUnit(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceDeleteUnit(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDeleteUnit']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Throws a draft away without touching inventory.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceDiscardDraft(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceDiscardDraft(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceDiscardDraft']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Builds a PDF presentation of a project and returns a link to it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGeneratePresentation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesGeneratePresentationResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceGeneratePresentation(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGeneratePresentation']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the cities of the reference book for navigation, filters and the city hub, named in the language of the request.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {boolean} [withGuideOnly] Keep only the cities whose guide has text. Off by default: navigation and filters list every city, the city hub lists the ones worth linking to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetCities(
      paginationPage?: string,
      paginationPerPage?: string,
      withGuideOnly?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesGetCitiesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceGetCities(
        paginationPage,
        paginationPerPage,
        withGuideOnly,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetCities']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns catalog counters for the CRM dashboard: how many projects, listings and developers exist, and how many of them are published.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetDashboardMetrics(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesDashboardMetricsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceGetDashboardMetrics(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetDashboardMetrics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one import draft with all parsed rows and their validation errors.
     * @param {string} id
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetImportDraft(
      id: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesGetImportDraftResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceGetImportDraft(
        id,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetImportDraft']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns everything a city landing page needs: description, statistics and the intro and outro texts shown above and below the listing grid.
     * @param {string} citySlug
     * @param {string} [locale] Locale code (ru, en, vn). An empty value falls back to Russian, so REST callers may omit it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetLocationPageData(
      citySlug: string,
      locale?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesGetLocationPageDataResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceGetLocationPageData(
          citySlug,
          locale,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetLocationPageData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the value ranges and option lists behind the project search filters — price bounds, room counts, amenities actually in use. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetResidentialComplexFilterValues(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesGetResidentialComplexFilterValuesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceGetResidentialComplexFilterValues(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceGetResidentialComplexFilterValues'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the catalog data a sitemap generator needs: slugs and last modification dates of every published entity. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetSEOData(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesGetSEODataResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceGetSEOData(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetSEOData']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Counts the units of a project by sale status in one call, so the CRM tab does not have to list them once per tile.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceGetUnitsSummary(
      residentialComplexId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesGetUnitsSummaryResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceGetUnitsSummary(
        residentialComplexId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceGetUnitsSummary']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns every published residential complex without pagination. Intended for sitemap and export jobs, not for interactive listings. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListAllResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesSearchResidentialComplexesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceListAllResidentialComplexes(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListAllResidentialComplexes']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists every city in the reference book, including those with no published content yet.
     * @param {boolean} [includeDeleted] Include cities that were deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListCitiesAdmin(
      includeDeleted?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesListCitiesAdminResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceListCitiesAdmin(
        includeDeleted,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListCitiesAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists import drafts with their review state.
     * @param {string} [residentialComplexId]
     * @param {Array<PropertiesServiceListImportDraftsStatusEnum>} [status] Keep drafts in any of these states.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListImportDrafts(
      residentialComplexId?: string,
      status?: Array<PropertiesServiceListImportDraftsStatusEnum>,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesListImportDraftsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceListImportDrafts(
        residentialComplexId,
        status,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListImportDrafts']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists staged import images awaiting a decision.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListImportImages(
      residentialComplexId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesListImportImagesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceListImportImages(
        residentialComplexId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListImportImages']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns the payment plans offered for a project: instalment schedules and the discounts attached to them.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListPaymentPlans(
      residentialComplexId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesListPaymentPlansResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceListPaymentPlans(
        residentialComplexId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListPaymentPlans']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the blocks of a project.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListResidentialComplexBlocks(
      residentialComplexId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesListResidentialComplexBlocksResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceListResidentialComplexBlocks(
          residentialComplexId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListResidentialComplexBlocks']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the marketing materials of a project with short-lived download links. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListResidentialComplexMaterials(
      residentialComplexId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesListResidentialComplexMaterialsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceListResidentialComplexMaterials(
          residentialComplexId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceListResidentialComplexMaterials'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: sales data, not public listing content — prices here are never exposed on the public site (DEV-1159, ADR-0038).
     * @summary Returns the unit mix of a project: how many units of each layout it has, in what area range and at what price.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListUnitMix(
      residentialComplexId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesListUnitMixResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceListUnitMix(
        residentialComplexId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListUnitMix']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Lists the units of a project, optionally filtered by block, floor or availability.
     * @param {string} residentialComplexId
     * @param {string} [filterBlockId]
     * @param {Array<PropertiesServiceListUnitsFilterStatusEnum>} [filterStatus] Keep units in any of these states.
     * @param {Array<string>} [filterNumberOfRooms]
     * @param {string} [filterFloor]
     * @param {Array<PropertiesServiceListUnitsFilterObjectTypeEnum>} [filterObjectType] Keep units of any of these types. OBJECT_TYPE_INVALID is a meaningful value here and means \&quot;type is not set\&quot;: such units are excluded from the showcase recompute, so the constructor needs a way to list them.   - OBJECT_TYPE_CONDOTEL: Hotel-style apartment sold to a private owner and operated as a hotel room.  - OBJECT_TYPE_SHOPHOUSE: Ground-floor retail with living space above.
     * @param {string} [filterUpdatedBefore] Keep units untouched since this moment. Set to the time the last price list was applied, it lists the units that file did not mention: they are most likely sold, yet still count towards the showcase (DEV-1219).
     * @param {string} [filterCode] Keep units whose code contains this substring, case-insensitively. A unit code is an identifier, not prose (\&quot;A1-05-02\&quot;), so full-text search is the wrong tool here: to_tsvector splits it on the dashes and a search for \&quot;05\&quot; finds nothing. The match always runs inside one project, which caps the scan at the roughly thousand units a project has.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceListUnits(
      residentialComplexId: string,
      filterBlockId?: string,
      filterStatus?: Array<PropertiesServiceListUnitsFilterStatusEnum>,
      filterNumberOfRooms?: Array<string>,
      filterFloor?: string,
      filterObjectType?: Array<PropertiesServiceListUnitsFilterObjectTypeEnum>,
      filterUpdatedBefore?: string,
      filterCode?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesListUnitsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceListUnits(
        residentialComplexId,
        filterBlockId,
        filterStatus,
        filterNumberOfRooms,
        filterFloor,
        filterObjectType,
        filterUpdatedBefore,
        filterCode,
        paginationPage,
        paginationPerPage,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceListUnits']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: computed for real — the rows are applied and the showcase recomputed inside a transaction that is then rolled back, so the preview cannot drift away from what apply actually does (DEV-1816). Holds the same locks as apply, so it is a one-off answer, not something to poll.
     * @summary Shows what applying the selected rows would do to the listings of the project: the listings as they are now, and as they would be afterwards.
     * @param {string} id
     * @param {PropertiesServicePreviewImportDraftShowcaseBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServicePreviewImportDraftShowcase(
      id: string,
      body: PropertiesServicePreviewImportDraftShowcaseBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesPreviewImportDraftShowcaseResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServicePreviewImportDraftShowcase(
          id,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServicePreviewImportDraftShowcase']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns one city with its full reference data and page texts.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadCityAdmin(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesReadCityAdminResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceReadCityAdmin(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadCityAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns a developer as shown on the public site.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadDeveloper(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesReadDeveloperResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceReadDeveloper(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadDeveloper']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns a developer with the fields the public view omits: moderation state, internal notes, unpublished media.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadDeveloperForAdmin(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReadDeveloperAdminResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReadDeveloperForAdmin(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadDeveloperForAdmin']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns a standalone listing by id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadObject(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesReadObjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceReadObject(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadObject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns a residential complex by id, as shown on the public site.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadResidentialComplex(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReadResidentialComplexResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReadResidentialComplex(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadResidentialComplex']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns a residential complex by its city and project slug — the pair that forms the public URL.
     * @param {string} citySlug
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadResidentialComplexBySlug(
      citySlug: string,
      slug: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReadResidentialComplexResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReadResidentialComplexBySlug(
          citySlug,
          slug,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReadResidentialComplexBySlug']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Returns a residential complex with the fields the public view omits: moderation state, sales data, unpublished media.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReadResidentialComplexForAdmin(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReadResidentialComplexAdminResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReadResidentialComplexForAdmin(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceReadResidentialComplexForAdmin'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: allowed even when the listings are recomputed from units — the gate covers the numbers of a row, not its gallery. An empty list clears the set, and the listing falls back to the pictures of its units (DEV-1817).
     * @summary Replaces the pictures of a listing: floor plans and finishing options.
     * @param {string} objectId
     * @param {PropertiesServiceReplaceObjectImagesBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReplaceObjectImages(
      objectId: string,
      body: PropertiesServiceReplaceObjectImagesBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReplaceObjectImagesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReplaceObjectImages(
          objectId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReplaceObjectImages']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Replaces the whole set of payment plans of a project in one transaction.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceReplacePaymentPlansBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReplacePaymentPlans(
      residentialComplexId: string,
      body: PropertiesServiceReplacePaymentPlansBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReplacePaymentPlansResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceReplacePaymentPlans(
          residentialComplexId,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReplacePaymentPlans']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Replaces the pictures of a unit.
     * @param {string} unitId
     * @param {PropertiesServiceReplaceUnitImagesBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReplaceUnitImages(
      unitId: string,
      body: PropertiesServiceReplaceUnitImagesBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesReplaceUnitImagesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceReplaceUnitImages(
        unitId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReplaceUnitImages']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Replaces the whole unit mix of a project in one transaction.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceReplaceUnitMixBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceReplaceUnitMix(
      residentialComplexId: string,
      body: PropertiesServiceReplaceUnitMixBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesReplaceUnitMixResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceReplaceUnitMix(
        residentialComplexId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceReplaceUnitMix']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Same search, but over every project regardless of visibility, and with the moderation fields attached.
     * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSearchAdminResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesSearchAdminResidentialComplexesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceSearchAdminResidentialComplexes(
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceSearchAdminResidentialComplexes'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Searches developers by name and city with pagination.
     * @param {PropertiesSearchDevelopersRequest} body Developer search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSearchDevelopers(
      body: PropertiesSearchDevelopersRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesSearchDevelopersResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceSearchDevelopers(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceSearchDevelopers']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Searches standalone listings by city, type, price and area.
     * @param {PropertiesSearchObjectsRequest} body Listing search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSearchObjects(
      body: PropertiesSearchObjectsRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesSearchObjectsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceSearchObjects(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceSearchObjects']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Searches published residential complexes by city, developer, price, room count and completion date. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSearchResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesSearchResidentialComplexesResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceSearchResidentialComplexes(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceSearchResidentialComplexes']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Points a draft at the project its rows will be applied to.
     * @param {string} id
     * @param {PropertiesServiceSetDraftResidentialComplexBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSetDraftResidentialComplex(
      id: string,
      body: PropertiesServiceSetDraftResidentialComplexBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesSetDraftResidentialComplexResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceSetDraftResidentialComplex(
          id,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceSetDraftResidentialComplex']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: separate from UpdateResidentialComplex because the rate is the base of every reward in a deal and is edited by a narrower circle — gated on properties:manage_commission (DEV-1873, ADR-0042). A project update leaves the rate untouched.
     * @summary Sets the commission the developer pays VINPROP for this project, together with any free-form terms.
     * @param {string} id
     * @param {PropertiesServiceSetResidentialComplexCommissionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSetResidentialComplexCommission(
      id: string,
      body: PropertiesServiceSetResidentialComplexCommissionBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesSetResidentialComplexCommissionResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceSetResidentialComplexCommission(
          id,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceSetResidentialComplexCommission'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: separate from UpdateResidentialComplex, which replaces the whole card — the project form and the Drive import would otherwise wipe the badge. Gated on properties:update (DEV-2299).
     * @summary Sets or clears the day sales of a project open. While set, the public site shows a \"sales start\" badge with that date.
     * @param {string} id
     * @param {PropertiesServiceSetResidentialComplexSalesStartBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceSetResidentialComplexSalesStart(
      id: string,
      body: PropertiesServiceSetResidentialComplexSalesStartBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesSetResidentialComplexSalesStartResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceSetResidentialComplexSalesStart(
          id,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceSetResidentialComplexSalesStart'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Updates a city: names, slug, coordinates and landing page texts.
     * @param {string} id
     * @param {PropertiesServiceUpdateCityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateCity(
      id: string,
      body: PropertiesServiceUpdateCityBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesUpdateCityResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceUpdateCity(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateCity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Replaces developer details. Fields left empty are cleared, not kept.
     * @param {PropertiesUpdateDeveloperRequest} body New details of an existing developer. Every field is replaced, so send the full state rather than a patch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateDeveloper(
      body: PropertiesUpdateDeveloperRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesUpdateDeveloperResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceUpdateDeveloper(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateDeveloper']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Saves a single edited row of a draft. Granular on purpose: reviewers edit rows one at a time, and saving the whole draft would make them race each other.
     * @param {string} id
     * @param {string} rowId
     * @param {PropertiesServiceUpdateDraftRowBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateDraftRow(
      id: string,
      rowId: string,
      body: PropertiesServiceUpdateDraftRowBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesUpdateDraftRowResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceUpdateDraftRow(
        id,
        rowId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateDraftRow']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Replaces the details of a standalone listing.
     * @param {PropertiesUpdateObjectRequest} body New details of an existing listing. Every field is replaced.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateObject(
      body: PropertiesUpdateObjectRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesUpdateObjectResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceUpdateObject(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateObject']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Repeated fields are replaced wholesale: an empty list clears the previous contents rather than leaving them untouched.
     * @summary Replaces the details of a residential complex.
     * @param {PropertiesUpdateResidentialComplexRequest} body New details of an existing residential complex.  The whole record is replaced: repeated fields and translations sent empty are cleared, not preserved. buf:lint:ignore FIELD_NO_DELETE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateResidentialComplex(
      body: PropertiesUpdateResidentialComplexRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesUpdateResidentialComplexResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceUpdateResidentialComplex(body, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateResidentialComplex']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Internal note: gated on properties:update (DEV-1003).
     * @summary Opens or closes a single project for real estate agents, without touching its public visibility.
     * @param {string} id
     * @param {PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateResidentialComplexAgentsAvailability(
      id: string,
      body: PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesUpdateResidentialComplexAgentsAvailabilityResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceUpdateResidentialComplexAgentsAvailability(
          id,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap[
          'PropertiesServiceApi.propertiesServiceUpdateResidentialComplexAgentsAvailability'
        ]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Renames a block or changes its floor count.
     * @param {string} id
     * @param {PropertiesServiceUpdateResidentialComplexBlockBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateResidentialComplexBlock(
      id: string,
      body: PropertiesServiceUpdateResidentialComplexBlockBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertiesUpdateResidentialComplexBlockResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.propertiesServiceUpdateResidentialComplexBlock(
          id,
          body,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateResidentialComplexBlock']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Updates a single unit: price, area, layout or sale status.
     * @param {string} id
     * @param {PropertiesServiceUpdateUnitBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async propertiesServiceUpdateUnit(
      id: string,
      body: PropertiesServiceUpdateUnitBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertiesUpdateUnitResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.propertiesServiceUpdateUnit(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['PropertiesServiceApi.propertiesServiceUpdateUnit']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * PropertiesServiceApi - factory interface
 * @export
 */
export const PropertiesServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PropertiesServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Applies the selected rows of a draft to the project in a single transaction, matching existing units by code. Rows left unselected stay in the draft.
     * @param {string} id
     * @param {PropertiesServiceApplyDraftRowsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceApplyDraftRows(
      id: string,
      body: PropertiesServiceApplyDraftRowsBody,
      options?: any,
    ): AxiosPromise<PropertiesApplyDraftRowsResponse> {
      return localVarFp
        .propertiesServiceApplyDraftRows(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: a price list brings hundreds of units and a handful of layouts — attaching plans one by one is not a thing anyone would do (DEV-1817).
     * @summary Copies the pictures of a unit to every other unit of the project sharing its layout code. Only the references are copied, not the files.
     * @param {string} unitId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceApplyUnitImagesToLayout(
      unitId: string,
      body: object,
      options?: any,
    ): AxiosPromise<PropertiesApplyUnitImagesToLayoutResponse> {
      return localVarFp
        .propertiesServiceApplyUnitImagesToLayout(unitId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Accepts a staged image: it moves from the private staging bucket into the public one and becomes an ordinary project image of the chosen type.
     * @param {string} id
     * @param {PropertiesServiceAssignImportImageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceAssignImportImage(
      id: string,
      body: PropertiesServiceAssignImportImageBody,
      options?: any,
    ): AxiosPromise<PropertiesAssignImportImageResponse> {
      return localVarFp
        .propertiesServiceAssignImportImage(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates or updates many units at once, matching them by unit code within the project. This is how an approved price list becomes inventory.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceBulkUpsertUnitsBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceBulkUpsertUnits(
      residentialComplexId: string,
      body: PropertiesServiceBulkUpsertUnitsBody,
      options?: any,
    ): AxiosPromise<PropertiesBulkUpsertUnitsResponse> {
      return localVarFp
        .propertiesServiceBulkUpsertUnits(residentialComplexId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Drops every staged image that was never assigned. Called when a project is published, so that unused imports do not linger in the bucket.
     * @param {string} residentialComplexId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCleanupImportImages(
      residentialComplexId: string,
      body: object,
      options?: any,
    ): AxiosPromise<PropertiesCleanupImportImagesResponse> {
      return localVarFp
        .propertiesServiceCleanupImportImages(residentialComplexId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a city to the reference book.
     * @param {PropertiesCreateCityRequest} body Details of a new city.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateCity(
      body: PropertiesCreateCityRequest,
      options?: any,
    ): AxiosPromise<PropertiesCreateCityResponse> {
      return localVarFp
        .propertiesServiceCreateCity(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Registers a developer. The company becomes selectable as the owner of a residential complex.
     * @param {PropertiesCreateDeveloperRequest} body Details of a new developer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateDeveloper(
      body: PropertiesCreateDeveloperRequest,
      options?: any,
    ): AxiosPromise<PropertiesCreateDeveloperResponse> {
      return localVarFp
        .propertiesServiceCreateDeveloper(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: drafts back the CRM import wizard, are gated on properties permissions and never reach the public site (DEV-1078).
     * @summary Starts an import draft from an uploaded price list: rows are parsed and held for review before anything touches live inventory.
     * @param {PropertiesCreateImportDraftRequest} body A parsed price list to hold for review.  Internal note: rows come from the harvester response and the CRM front end orchestrates the flow (DEV-1078, DEV-1081).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateImportDraft(
      body: PropertiesCreateImportDraftRequest,
      options?: any,
    ): AxiosPromise<PropertiesCreateImportDraftResponse> {
      return localVarFp
        .propertiesServiceCreateImportDraft(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a standalone listing — a property sold on its own rather than as part of a project.
     * @param {PropertiesCreateObjectRequest} body Details of a new listing.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateObject(
      body: PropertiesCreateObjectRequest,
      options?: any,
    ): AxiosPromise<PropertiesCreateObjectResponse> {
      return localVarFp
        .propertiesServiceCreateObject(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Creates a residential complex (a project). It stays invisible on the public site until its visibility is switched on.
     * @param {PropertiesCreateResidentialComplexRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateResidentialComplex(
      body: PropertiesCreateResidentialComplexRequest,
      options?: any,
    ): AxiosPromise<PropertiesCreateResidentialComplexResponse> {
      return localVarFp
        .propertiesServiceCreateResidentialComplex(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: blocks and units back the CRM project constructor and are gated on properties permissions; units never appear in public responses (DEV-1077, ADR-0035). The literal routes below (.../blocks/{id}) are declared after DeleteResidentialComplex on purpose — grpc-gateway matches in declaration order, and the {id} pattern would otherwise swallow them.
     * @summary Adds a block (building) to a project.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceCreateResidentialComplexBlockBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateResidentialComplexBlock(
      residentialComplexId: string,
      body: PropertiesServiceCreateResidentialComplexBlockBody,
      options?: any,
    ): AxiosPromise<PropertiesCreateResidentialComplexBlockResponse> {
      return localVarFp
        .propertiesServiceCreateResidentialComplexBlock(residentialComplexId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: materials live in a private bucket and are served through presigned links; the whole group is gated on properties permissions (DEV-1021).
     * @summary Attaches a marketing material (brochure, price list, floor plan) to a project.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceCreateResidentialComplexMaterialBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateResidentialComplexMaterial(
      residentialComplexId: string,
      body: PropertiesServiceCreateResidentialComplexMaterialBody,
      options?: any,
    ): AxiosPromise<PropertiesCreateResidentialComplexMaterialResponse> {
      return localVarFp
        .propertiesServiceCreateResidentialComplexMaterial(residentialComplexId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Adds a single unit (apartment) to a project.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceCreateUnitBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceCreateUnit(
      residentialComplexId: string,
      body: PropertiesServiceCreateUnitBody,
      options?: any,
    ): AxiosPromise<PropertiesCreateUnitResponse> {
      return localVarFp
        .propertiesServiceCreateUnit(residentialComplexId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a city. Refused while content still references it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteCity(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteCity(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Soft-deletes a developer. Residential complexes already linked to it keep the reference and stay readable.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteDeveloper(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteDeveloper(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Discards a staged image together with its file.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteImportImage(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteImportImage(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Soft-deletes a standalone listing. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteObject(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteObject(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Soft-deletes a residential complex together with its blocks and units.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteResidentialComplex(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteResidentialComplex(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a block together with the units inside it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteResidentialComplexBlock(
      id: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteResidentialComplexBlock(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Removes a marketing material and its stored file.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteResidentialComplexMaterial(
      id: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteResidentialComplexMaterial(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Deletes a unit.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDeleteUnit(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDeleteUnit(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Throws a draft away without touching inventory.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceDiscardDraft(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .propertiesServiceDiscardDraft(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Builds a PDF presentation of a project and returns a link to it.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGeneratePresentation(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesGeneratePresentationResponse> {
      return localVarFp
        .propertiesServiceGeneratePresentation(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the cities of the reference book for navigation, filters and the city hub, named in the language of the request.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {boolean} [withGuideOnly] Keep only the cities whose guide has text. Off by default: navigation and filters list every city, the city hub lists the ones worth linking to.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetCities(
      paginationPage?: string,
      paginationPerPage?: string,
      withGuideOnly?: boolean,
      options?: any,
    ): AxiosPromise<PropertiesGetCitiesResponse> {
      return localVarFp
        .propertiesServiceGetCities(paginationPage, paginationPerPage, withGuideOnly, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns catalog counters for the CRM dashboard: how many projects, listings and developers exist, and how many of them are published.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetDashboardMetrics(
      options?: any,
    ): AxiosPromise<PropertiesDashboardMetricsResponse> {
      return localVarFp
        .propertiesServiceGetDashboardMetrics(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one import draft with all parsed rows and their validation errors.
     * @param {string} id
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetImportDraft(
      id: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<PropertiesGetImportDraftResponse> {
      return localVarFp
        .propertiesServiceGetImportDraft(id, paginationPage, paginationPerPage, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns everything a city landing page needs: description, statistics and the intro and outro texts shown above and below the listing grid.
     * @param {string} citySlug
     * @param {string} [locale] Locale code (ru, en, vn). An empty value falls back to Russian, so REST callers may omit it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetLocationPageData(
      citySlug: string,
      locale?: string,
      options?: any,
    ): AxiosPromise<PropertiesGetLocationPageDataResponse> {
      return localVarFp
        .propertiesServiceGetLocationPageData(citySlug, locale, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the value ranges and option lists behind the project search filters — price bounds, room counts, amenities actually in use. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetResidentialComplexFilterValues(
      options?: any,
    ): AxiosPromise<PropertiesGetResidentialComplexFilterValuesResponse> {
      return localVarFp
        .propertiesServiceGetResidentialComplexFilterValues(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the catalog data a sitemap generator needs: slugs and last modification dates of every published entity. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetSEOData(options?: any): AxiosPromise<PropertiesGetSEODataResponse> {
      return localVarFp
        .propertiesServiceGetSEOData(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Counts the units of a project by sale status in one call, so the CRM tab does not have to list them once per tile.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceGetUnitsSummary(
      residentialComplexId: string,
      options?: any,
    ): AxiosPromise<PropertiesGetUnitsSummaryResponse> {
      return localVarFp
        .propertiesServiceGetUnitsSummary(residentialComplexId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns every published residential complex without pagination. Intended for sitemap and export jobs, not for interactive listings. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListAllResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchResidentialComplexesResponse> {
      return localVarFp
        .propertiesServiceListAllResidentialComplexes(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists every city in the reference book, including those with no published content yet.
     * @param {boolean} [includeDeleted] Include cities that were deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListCitiesAdmin(
      includeDeleted?: boolean,
      options?: any,
    ): AxiosPromise<PropertiesListCitiesAdminResponse> {
      return localVarFp
        .propertiesServiceListCitiesAdmin(includeDeleted, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists import drafts with their review state.
     * @param {string} [residentialComplexId]
     * @param {Array<PropertiesServiceListImportDraftsStatusEnum>} [status] Keep drafts in any of these states.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListImportDrafts(
      residentialComplexId?: string,
      status?: Array<PropertiesServiceListImportDraftsStatusEnum>,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<PropertiesListImportDraftsResponse> {
      return localVarFp
        .propertiesServiceListImportDrafts(
          residentialComplexId,
          status,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists staged import images awaiting a decision.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListImportImages(
      residentialComplexId: string,
      options?: any,
    ): AxiosPromise<PropertiesListImportImagesResponse> {
      return localVarFp
        .propertiesServiceListImportImages(residentialComplexId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns the payment plans offered for a project: instalment schedules and the discounts attached to them.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListPaymentPlans(
      residentialComplexId: string,
      options?: any,
    ): AxiosPromise<PropertiesListPaymentPlansResponse> {
      return localVarFp
        .propertiesServiceListPaymentPlans(residentialComplexId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the blocks of a project.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListResidentialComplexBlocks(
      residentialComplexId: string,
      options?: any,
    ): AxiosPromise<PropertiesListResidentialComplexBlocksResponse> {
      return localVarFp
        .propertiesServiceListResidentialComplexBlocks(residentialComplexId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the marketing materials of a project with short-lived download links. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListResidentialComplexMaterials(
      residentialComplexId: string,
      options?: any,
    ): AxiosPromise<PropertiesListResidentialComplexMaterialsResponse> {
      return localVarFp
        .propertiesServiceListResidentialComplexMaterials(residentialComplexId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: sales data, not public listing content — prices here are never exposed on the public site (DEV-1159, ADR-0038).
     * @summary Returns the unit mix of a project: how many units of each layout it has, in what area range and at what price.
     * @param {string} residentialComplexId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListUnitMix(
      residentialComplexId: string,
      options?: any,
    ): AxiosPromise<PropertiesListUnitMixResponse> {
      return localVarFp
        .propertiesServiceListUnitMix(residentialComplexId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Lists the units of a project, optionally filtered by block, floor or availability.
     * @param {string} residentialComplexId
     * @param {string} [filterBlockId]
     * @param {Array<PropertiesServiceListUnitsFilterStatusEnum>} [filterStatus] Keep units in any of these states.
     * @param {Array<string>} [filterNumberOfRooms]
     * @param {string} [filterFloor]
     * @param {Array<PropertiesServiceListUnitsFilterObjectTypeEnum>} [filterObjectType] Keep units of any of these types. OBJECT_TYPE_INVALID is a meaningful value here and means \&quot;type is not set\&quot;: such units are excluded from the showcase recompute, so the constructor needs a way to list them.   - OBJECT_TYPE_CONDOTEL: Hotel-style apartment sold to a private owner and operated as a hotel room.  - OBJECT_TYPE_SHOPHOUSE: Ground-floor retail with living space above.
     * @param {string} [filterUpdatedBefore] Keep units untouched since this moment. Set to the time the last price list was applied, it lists the units that file did not mention: they are most likely sold, yet still count towards the showcase (DEV-1219).
     * @param {string} [filterCode] Keep units whose code contains this substring, case-insensitively. A unit code is an identifier, not prose (\&quot;A1-05-02\&quot;), so full-text search is the wrong tool here: to_tsvector splits it on the dashes and a search for \&quot;05\&quot; finds nothing. The match always runs inside one project, which caps the scan at the roughly thousand units a project has.
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceListUnits(
      residentialComplexId: string,
      filterBlockId?: string,
      filterStatus?: Array<PropertiesServiceListUnitsFilterStatusEnum>,
      filterNumberOfRooms?: Array<string>,
      filterFloor?: string,
      filterObjectType?: Array<PropertiesServiceListUnitsFilterObjectTypeEnum>,
      filterUpdatedBefore?: string,
      filterCode?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<PropertiesListUnitsResponse> {
      return localVarFp
        .propertiesServiceListUnits(
          residentialComplexId,
          filterBlockId,
          filterStatus,
          filterNumberOfRooms,
          filterFloor,
          filterObjectType,
          filterUpdatedBefore,
          filterCode,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: computed for real — the rows are applied and the showcase recomputed inside a transaction that is then rolled back, so the preview cannot drift away from what apply actually does (DEV-1816). Holds the same locks as apply, so it is a one-off answer, not something to poll.
     * @summary Shows what applying the selected rows would do to the listings of the project: the listings as they are now, and as they would be afterwards.
     * @param {string} id
     * @param {PropertiesServicePreviewImportDraftShowcaseBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServicePreviewImportDraftShowcase(
      id: string,
      body: PropertiesServicePreviewImportDraftShowcaseBody,
      options?: any,
    ): AxiosPromise<PropertiesPreviewImportDraftShowcaseResponse> {
      return localVarFp
        .propertiesServicePreviewImportDraftShowcase(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns one city with its full reference data and page texts.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadCityAdmin(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadCityAdminResponse> {
      return localVarFp
        .propertiesServiceReadCityAdmin(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns a developer as shown on the public site.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadDeveloper(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadDeveloperResponse> {
      return localVarFp
        .propertiesServiceReadDeveloper(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns a developer with the fields the public view omits: moderation state, internal notes, unpublished media.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadDeveloperForAdmin(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadDeveloperAdminResponse> {
      return localVarFp
        .propertiesServiceReadDeveloperForAdmin(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns a standalone listing by id.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadObject(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadObjectResponse> {
      return localVarFp
        .propertiesServiceReadObject(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns a residential complex by id, as shown on the public site.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplex(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadResidentialComplexResponse> {
      return localVarFp
        .propertiesServiceReadResidentialComplex(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns a residential complex by its city and project slug — the pair that forms the public URL.
     * @param {string} citySlug
     * @param {string} slug
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplexBySlug(
      citySlug: string,
      slug: string,
      options?: any,
    ): AxiosPromise<PropertiesReadResidentialComplexResponse> {
      return localVarFp
        .propertiesServiceReadResidentialComplexBySlug(citySlug, slug, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Returns a residential complex with the fields the public view omits: moderation state, sales data, unpublished media.
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReadResidentialComplexForAdmin(
      id: string,
      options?: any,
    ): AxiosPromise<PropertiesReadResidentialComplexAdminResponse> {
      return localVarFp
        .propertiesServiceReadResidentialComplexForAdmin(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: allowed even when the listings are recomputed from units — the gate covers the numbers of a row, not its gallery. An empty list clears the set, and the listing falls back to the pictures of its units (DEV-1817).
     * @summary Replaces the pictures of a listing: floor plans and finishing options.
     * @param {string} objectId
     * @param {PropertiesServiceReplaceObjectImagesBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReplaceObjectImages(
      objectId: string,
      body: PropertiesServiceReplaceObjectImagesBody,
      options?: any,
    ): AxiosPromise<PropertiesReplaceObjectImagesResponse> {
      return localVarFp
        .propertiesServiceReplaceObjectImages(objectId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Replaces the whole set of payment plans of a project in one transaction.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceReplacePaymentPlansBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReplacePaymentPlans(
      residentialComplexId: string,
      body: PropertiesServiceReplacePaymentPlansBody,
      options?: any,
    ): AxiosPromise<PropertiesReplacePaymentPlansResponse> {
      return localVarFp
        .propertiesServiceReplacePaymentPlans(residentialComplexId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Replaces the pictures of a unit.
     * @param {string} unitId
     * @param {PropertiesServiceReplaceUnitImagesBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReplaceUnitImages(
      unitId: string,
      body: PropertiesServiceReplaceUnitImagesBody,
      options?: any,
    ): AxiosPromise<PropertiesReplaceUnitImagesResponse> {
      return localVarFp
        .propertiesServiceReplaceUnitImages(unitId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Replaces the whole unit mix of a project in one transaction.
     * @param {string} residentialComplexId
     * @param {PropertiesServiceReplaceUnitMixBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceReplaceUnitMix(
      residentialComplexId: string,
      body: PropertiesServiceReplaceUnitMixBody,
      options?: any,
    ): AxiosPromise<PropertiesReplaceUnitMixResponse> {
      return localVarFp
        .propertiesServiceReplaceUnitMix(residentialComplexId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Same search, but over every project regardless of visibility, and with the moderation fields attached.
     * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchAdminResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchAdminResidentialComplexesResponse> {
      return localVarFp
        .propertiesServiceSearchAdminResidentialComplexes(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Searches developers by name and city with pagination.
     * @param {PropertiesSearchDevelopersRequest} body Developer search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchDevelopers(
      body: PropertiesSearchDevelopersRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchDevelopersResponse> {
      return localVarFp
        .propertiesServiceSearchDevelopers(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Searches standalone listings by city, type, price and area.
     * @param {PropertiesSearchObjectsRequest} body Listing search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchObjects(
      body: PropertiesSearchObjectsRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchObjectsResponse> {
      return localVarFp
        .propertiesServiceSearchObjects(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Searches published residential complexes by city, developer, price, room count and completion date. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
     * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSearchResidentialComplexes(
      body: PropertiesSearchResidentialComplexesRequest,
      options?: any,
    ): AxiosPromise<PropertiesSearchResidentialComplexesResponse> {
      return localVarFp
        .propertiesServiceSearchResidentialComplexes(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Points a draft at the project its rows will be applied to.
     * @param {string} id
     * @param {PropertiesServiceSetDraftResidentialComplexBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSetDraftResidentialComplex(
      id: string,
      body: PropertiesServiceSetDraftResidentialComplexBody,
      options?: any,
    ): AxiosPromise<PropertiesSetDraftResidentialComplexResponse> {
      return localVarFp
        .propertiesServiceSetDraftResidentialComplex(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: separate from UpdateResidentialComplex because the rate is the base of every reward in a deal and is edited by a narrower circle — gated on properties:manage_commission (DEV-1873, ADR-0042). A project update leaves the rate untouched.
     * @summary Sets the commission the developer pays VINPROP for this project, together with any free-form terms.
     * @param {string} id
     * @param {PropertiesServiceSetResidentialComplexCommissionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSetResidentialComplexCommission(
      id: string,
      body: PropertiesServiceSetResidentialComplexCommissionBody,
      options?: any,
    ): AxiosPromise<PropertiesSetResidentialComplexCommissionResponse> {
      return localVarFp
        .propertiesServiceSetResidentialComplexCommission(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: separate from UpdateResidentialComplex, which replaces the whole card — the project form and the Drive import would otherwise wipe the badge. Gated on properties:update (DEV-2299).
     * @summary Sets or clears the day sales of a project open. While set, the public site shows a \"sales start\" badge with that date.
     * @param {string} id
     * @param {PropertiesServiceSetResidentialComplexSalesStartBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceSetResidentialComplexSalesStart(
      id: string,
      body: PropertiesServiceSetResidentialComplexSalesStartBody,
      options?: any,
    ): AxiosPromise<PropertiesSetResidentialComplexSalesStartResponse> {
      return localVarFp
        .propertiesServiceSetResidentialComplexSalesStart(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Updates a city: names, slug, coordinates and landing page texts.
     * @param {string} id
     * @param {PropertiesServiceUpdateCityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateCity(
      id: string,
      body: PropertiesServiceUpdateCityBody,
      options?: any,
    ): AxiosPromise<PropertiesUpdateCityResponse> {
      return localVarFp
        .propertiesServiceUpdateCity(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Replaces developer details. Fields left empty are cleared, not kept.
     * @param {PropertiesUpdateDeveloperRequest} body New details of an existing developer. Every field is replaced, so send the full state rather than a patch.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateDeveloper(
      body: PropertiesUpdateDeveloperRequest,
      options?: any,
    ): AxiosPromise<PropertiesUpdateDeveloperResponse> {
      return localVarFp
        .propertiesServiceUpdateDeveloper(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Saves a single edited row of a draft. Granular on purpose: reviewers edit rows one at a time, and saving the whole draft would make them race each other.
     * @param {string} id
     * @param {string} rowId
     * @param {PropertiesServiceUpdateDraftRowBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateDraftRow(
      id: string,
      rowId: string,
      body: PropertiesServiceUpdateDraftRowBody,
      options?: any,
    ): AxiosPromise<PropertiesUpdateDraftRowResponse> {
      return localVarFp
        .propertiesServiceUpdateDraftRow(id, rowId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Replaces the details of a standalone listing.
     * @param {PropertiesUpdateObjectRequest} body New details of an existing listing. Every field is replaced.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateObject(
      body: PropertiesUpdateObjectRequest,
      options?: any,
    ): AxiosPromise<PropertiesUpdateObjectResponse> {
      return localVarFp
        .propertiesServiceUpdateObject(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Repeated fields are replaced wholesale: an empty list clears the previous contents rather than leaving them untouched.
     * @summary Replaces the details of a residential complex.
     * @param {PropertiesUpdateResidentialComplexRequest} body New details of an existing residential complex.  The whole record is replaced: repeated fields and translations sent empty are cleared, not preserved. buf:lint:ignore FIELD_NO_DELETE
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplex(
      body: PropertiesUpdateResidentialComplexRequest,
      options?: any,
    ): AxiosPromise<PropertiesUpdateResidentialComplexResponse> {
      return localVarFp
        .propertiesServiceUpdateResidentialComplex(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Internal note: gated on properties:update (DEV-1003).
     * @summary Opens or closes a single project for real estate agents, without touching its public visibility.
     * @param {string} id
     * @param {PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplexAgentsAvailability(
      id: string,
      body: PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody,
      options?: any,
    ): AxiosPromise<PropertiesUpdateResidentialComplexAgentsAvailabilityResponse> {
      return localVarFp
        .propertiesServiceUpdateResidentialComplexAgentsAvailability(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Renames a block or changes its floor count.
     * @param {string} id
     * @param {PropertiesServiceUpdateResidentialComplexBlockBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateResidentialComplexBlock(
      id: string,
      body: PropertiesServiceUpdateResidentialComplexBlockBody,
      options?: any,
    ): AxiosPromise<PropertiesUpdateResidentialComplexBlockResponse> {
      return localVarFp
        .propertiesServiceUpdateResidentialComplexBlock(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Updates a single unit: price, area, layout or sale status.
     * @param {string} id
     * @param {PropertiesServiceUpdateUnitBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertiesServiceUpdateUnit(
      id: string,
      body: PropertiesServiceUpdateUnitBody,
      options?: any,
    ): AxiosPromise<PropertiesUpdateUnitResponse> {
      return localVarFp
        .propertiesServiceUpdateUnit(id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * PropertiesServiceApi - object-oriented interface
 * @export
 * @class PropertiesServiceApi
 * @extends {BaseAPI}
 */
export class PropertiesServiceApi extends BaseAPI {
  /**
   *
   * @summary Applies the selected rows of a draft to the project in a single transaction, matching existing units by code. Rows left unselected stay in the draft.
   * @param {string} id
   * @param {PropertiesServiceApplyDraftRowsBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceApplyDraftRows(
    id: string,
    body: PropertiesServiceApplyDraftRowsBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceApplyDraftRows(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: a price list brings hundreds of units and a handful of layouts — attaching plans one by one is not a thing anyone would do (DEV-1817).
   * @summary Copies the pictures of a unit to every other unit of the project sharing its layout code. Only the references are copied, not the files.
   * @param {string} unitId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceApplyUnitImagesToLayout(
    unitId: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceApplyUnitImagesToLayout(unitId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Accepts a staged image: it moves from the private staging bucket into the public one and becomes an ordinary project image of the chosen type.
   * @param {string} id
   * @param {PropertiesServiceAssignImportImageBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceAssignImportImage(
    id: string,
    body: PropertiesServiceAssignImportImageBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceAssignImportImage(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates or updates many units at once, matching them by unit code within the project. This is how an approved price list becomes inventory.
   * @param {string} residentialComplexId
   * @param {PropertiesServiceBulkUpsertUnitsBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceBulkUpsertUnits(
    residentialComplexId: string,
    body: PropertiesServiceBulkUpsertUnitsBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceBulkUpsertUnits(residentialComplexId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Drops every staged image that was never assigned. Called when a project is published, so that unused imports do not linger in the bucket.
   * @param {string} residentialComplexId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCleanupImportImages(
    residentialComplexId: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCleanupImportImages(residentialComplexId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a city to the reference book.
   * @param {PropertiesCreateCityRequest} body Details of a new city.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateCity(
    body: PropertiesCreateCityRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateCity(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Registers a developer. The company becomes selectable as the owner of a residential complex.
   * @param {PropertiesCreateDeveloperRequest} body Details of a new developer.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateDeveloper(
    body: PropertiesCreateDeveloperRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateDeveloper(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: drafts back the CRM import wizard, are gated on properties permissions and never reach the public site (DEV-1078).
   * @summary Starts an import draft from an uploaded price list: rows are parsed and held for review before anything touches live inventory.
   * @param {PropertiesCreateImportDraftRequest} body A parsed price list to hold for review.  Internal note: rows come from the harvester response and the CRM front end orchestrates the flow (DEV-1078, DEV-1081).
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateImportDraft(
    body: PropertiesCreateImportDraftRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateImportDraft(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a standalone listing — a property sold on its own rather than as part of a project.
   * @param {PropertiesCreateObjectRequest} body Details of a new listing.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateObject(
    body: PropertiesCreateObjectRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateObject(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Creates a residential complex (a project). It stays invisible on the public site until its visibility is switched on.
   * @param {PropertiesCreateResidentialComplexRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateResidentialComplex(
    body: PropertiesCreateResidentialComplexRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateResidentialComplex(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: blocks and units back the CRM project constructor and are gated on properties permissions; units never appear in public responses (DEV-1077, ADR-0035). The literal routes below (.../blocks/{id}) are declared after DeleteResidentialComplex on purpose — grpc-gateway matches in declaration order, and the {id} pattern would otherwise swallow them.
   * @summary Adds a block (building) to a project.
   * @param {string} residentialComplexId
   * @param {PropertiesServiceCreateResidentialComplexBlockBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateResidentialComplexBlock(
    residentialComplexId: string,
    body: PropertiesServiceCreateResidentialComplexBlockBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateResidentialComplexBlock(residentialComplexId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: materials live in a private bucket and are served through presigned links; the whole group is gated on properties permissions (DEV-1021).
   * @summary Attaches a marketing material (brochure, price list, floor plan) to a project.
   * @param {string} residentialComplexId
   * @param {PropertiesServiceCreateResidentialComplexMaterialBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateResidentialComplexMaterial(
    residentialComplexId: string,
    body: PropertiesServiceCreateResidentialComplexMaterialBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateResidentialComplexMaterial(residentialComplexId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Adds a single unit (apartment) to a project.
   * @param {string} residentialComplexId
   * @param {PropertiesServiceCreateUnitBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceCreateUnit(
    residentialComplexId: string,
    body: PropertiesServiceCreateUnitBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceCreateUnit(residentialComplexId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a city. Refused while content still references it.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteCity(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteCity(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Soft-deletes a developer. Residential complexes already linked to it keep the reference and stay readable.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteDeveloper(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteDeveloper(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Discards a staged image together with its file.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteImportImage(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteImportImage(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Soft-deletes a standalone listing. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteObject(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteObject(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Soft-deletes a residential complex together with its blocks and units.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteResidentialComplex(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteResidentialComplex(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a block together with the units inside it.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteResidentialComplexBlock(
    id: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteResidentialComplexBlock(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Removes a marketing material and its stored file.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteResidentialComplexMaterial(
    id: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteResidentialComplexMaterial(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Deletes a unit.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDeleteUnit(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDeleteUnit(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Throws a draft away without touching inventory.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceDiscardDraft(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceDiscardDraft(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Builds a PDF presentation of a project and returns a link to it.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGeneratePresentation(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGeneratePresentation(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the cities of the reference book for navigation, filters and the city hub, named in the language of the request.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {boolean} [withGuideOnly] Keep only the cities whose guide has text. Off by default: navigation and filters list every city, the city hub lists the ones worth linking to.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetCities(
    paginationPage?: string,
    paginationPerPage?: string,
    withGuideOnly?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetCities(paginationPage, paginationPerPage, withGuideOnly, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns catalog counters for the CRM dashboard: how many projects, listings and developers exist, and how many of them are published.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetDashboardMetrics(options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetDashboardMetrics(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one import draft with all parsed rows and their validation errors.
   * @param {string} id
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetImportDraft(
    id: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetImportDraft(id, paginationPage, paginationPerPage, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns everything a city landing page needs: description, statistics and the intro and outro texts shown above and below the listing grid.
   * @param {string} citySlug
   * @param {string} [locale] Locale code (ru, en, vn). An empty value falls back to Russian, so REST callers may omit it.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetLocationPageData(
    citySlug: string,
    locale?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetLocationPageData(citySlug, locale, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the value ranges and option lists behind the project search filters — price bounds, room counts, amenities actually in use. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetResidentialComplexFilterValues(options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetResidentialComplexFilterValues(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the catalog data a sitemap generator needs: slugs and last modification dates of every published entity. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetSEOData(options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetSEOData(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Counts the units of a project by sale status in one call, so the CRM tab does not have to list them once per tile.
   * @param {string} residentialComplexId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceGetUnitsSummary(
    residentialComplexId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceGetUnitsSummary(residentialComplexId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns every published residential complex without pagination. Intended for sitemap and export jobs, not for interactive listings. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListAllResidentialComplexes(
    body: PropertiesSearchResidentialComplexesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListAllResidentialComplexes(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists every city in the reference book, including those with no published content yet.
   * @param {boolean} [includeDeleted] Include cities that were deleted.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListCitiesAdmin(
    includeDeleted?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListCitiesAdmin(includeDeleted, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists import drafts with their review state.
   * @param {string} [residentialComplexId]
   * @param {Array<PropertiesServiceListImportDraftsStatusEnum>} [status] Keep drafts in any of these states.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListImportDrafts(
    residentialComplexId?: string,
    status?: Array<PropertiesServiceListImportDraftsStatusEnum>,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListImportDrafts(
        residentialComplexId,
        status,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists staged import images awaiting a decision.
   * @param {string} residentialComplexId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListImportImages(
    residentialComplexId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListImportImages(residentialComplexId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns the payment plans offered for a project: instalment schedules and the discounts attached to them.
   * @param {string} residentialComplexId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListPaymentPlans(
    residentialComplexId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListPaymentPlans(residentialComplexId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the blocks of a project.
   * @param {string} residentialComplexId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListResidentialComplexBlocks(
    residentialComplexId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListResidentialComplexBlocks(residentialComplexId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the marketing materials of a project with short-lived download links. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {string} residentialComplexId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListResidentialComplexMaterials(
    residentialComplexId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListResidentialComplexMaterials(residentialComplexId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: sales data, not public listing content — prices here are never exposed on the public site (DEV-1159, ADR-0038).
   * @summary Returns the unit mix of a project: how many units of each layout it has, in what area range and at what price.
   * @param {string} residentialComplexId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListUnitMix(
    residentialComplexId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListUnitMix(residentialComplexId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Lists the units of a project, optionally filtered by block, floor or availability.
   * @param {string} residentialComplexId
   * @param {string} [filterBlockId]
   * @param {Array<PropertiesServiceListUnitsFilterStatusEnum>} [filterStatus] Keep units in any of these states.
   * @param {Array<string>} [filterNumberOfRooms]
   * @param {string} [filterFloor]
   * @param {Array<PropertiesServiceListUnitsFilterObjectTypeEnum>} [filterObjectType] Keep units of any of these types. OBJECT_TYPE_INVALID is a meaningful value here and means \&quot;type is not set\&quot;: such units are excluded from the showcase recompute, so the constructor needs a way to list them.   - OBJECT_TYPE_CONDOTEL: Hotel-style apartment sold to a private owner and operated as a hotel room.  - OBJECT_TYPE_SHOPHOUSE: Ground-floor retail with living space above.
   * @param {string} [filterUpdatedBefore] Keep units untouched since this moment. Set to the time the last price list was applied, it lists the units that file did not mention: they are most likely sold, yet still count towards the showcase (DEV-1219).
   * @param {string} [filterCode] Keep units whose code contains this substring, case-insensitively. A unit code is an identifier, not prose (\&quot;A1-05-02\&quot;), so full-text search is the wrong tool here: to_tsvector splits it on the dashes and a search for \&quot;05\&quot; finds nothing. The match always runs inside one project, which caps the scan at the roughly thousand units a project has.
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceListUnits(
    residentialComplexId: string,
    filterBlockId?: string,
    filterStatus?: Array<PropertiesServiceListUnitsFilterStatusEnum>,
    filterNumberOfRooms?: Array<string>,
    filterFloor?: string,
    filterObjectType?: Array<PropertiesServiceListUnitsFilterObjectTypeEnum>,
    filterUpdatedBefore?: string,
    filterCode?: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceListUnits(
        residentialComplexId,
        filterBlockId,
        filterStatus,
        filterNumberOfRooms,
        filterFloor,
        filterObjectType,
        filterUpdatedBefore,
        filterCode,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: computed for real — the rows are applied and the showcase recomputed inside a transaction that is then rolled back, so the preview cannot drift away from what apply actually does (DEV-1816). Holds the same locks as apply, so it is a one-off answer, not something to poll.
   * @summary Shows what applying the selected rows would do to the listings of the project: the listings as they are now, and as they would be afterwards.
   * @param {string} id
   * @param {PropertiesServicePreviewImportDraftShowcaseBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServicePreviewImportDraftShowcase(
    id: string,
    body: PropertiesServicePreviewImportDraftShowcaseBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServicePreviewImportDraftShowcase(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns one city with its full reference data and page texts.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadCityAdmin(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadCityAdmin(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns a developer as shown on the public site.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadDeveloper(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadDeveloper(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns a developer with the fields the public view omits: moderation state, internal notes, unpublished media.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadDeveloperForAdmin(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadDeveloperForAdmin(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns a standalone listing by id.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadObject(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadObject(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns a residential complex by id, as shown on the public site.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadResidentialComplex(id: string, options?: RawAxiosRequestConfig) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadResidentialComplex(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns a residential complex by its city and project slug — the pair that forms the public URL.
   * @param {string} citySlug
   * @param {string} slug
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadResidentialComplexBySlug(
    citySlug: string,
    slug: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadResidentialComplexBySlug(citySlug, slug, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Returns a residential complex with the fields the public view omits: moderation state, sales data, unpublished media.
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReadResidentialComplexForAdmin(
    id: string,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReadResidentialComplexForAdmin(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: allowed even when the listings are recomputed from units — the gate covers the numbers of a row, not its gallery. An empty list clears the set, and the listing falls back to the pictures of its units (DEV-1817).
   * @summary Replaces the pictures of a listing: floor plans and finishing options.
   * @param {string} objectId
   * @param {PropertiesServiceReplaceObjectImagesBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReplaceObjectImages(
    objectId: string,
    body: PropertiesServiceReplaceObjectImagesBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReplaceObjectImages(objectId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Replaces the whole set of payment plans of a project in one transaction.
   * @param {string} residentialComplexId
   * @param {PropertiesServiceReplacePaymentPlansBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReplacePaymentPlans(
    residentialComplexId: string,
    body: PropertiesServiceReplacePaymentPlansBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReplacePaymentPlans(residentialComplexId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Replaces the pictures of a unit.
   * @param {string} unitId
   * @param {PropertiesServiceReplaceUnitImagesBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReplaceUnitImages(
    unitId: string,
    body: PropertiesServiceReplaceUnitImagesBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReplaceUnitImages(unitId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Replaces the whole unit mix of a project in one transaction.
   * @param {string} residentialComplexId
   * @param {PropertiesServiceReplaceUnitMixBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceReplaceUnitMix(
    residentialComplexId: string,
    body: PropertiesServiceReplaceUnitMixBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceReplaceUnitMix(residentialComplexId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Same search, but over every project regardless of visibility, and with the moderation fields attached.
   * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSearchAdminResidentialComplexes(
    body: PropertiesSearchResidentialComplexesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSearchAdminResidentialComplexes(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Searches developers by name and city with pagination.
   * @param {PropertiesSearchDevelopersRequest} body Developer search parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSearchDevelopers(
    body: PropertiesSearchDevelopersRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSearchDevelopers(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Searches standalone listings by city, type, price and area.
   * @param {PropertiesSearchObjectsRequest} body Listing search parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSearchObjects(
    body: PropertiesSearchObjectsRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSearchObjects(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Searches published residential complexes by city, developer, price, room count and completion date. buf:lint:ignore RPC_REQUEST_RESPONSE_UNIQUE
   * @param {PropertiesSearchResidentialComplexesRequest} body Residential complex search parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSearchResidentialComplexes(
    body: PropertiesSearchResidentialComplexesRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSearchResidentialComplexes(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Points a draft at the project its rows will be applied to.
   * @param {string} id
   * @param {PropertiesServiceSetDraftResidentialComplexBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSetDraftResidentialComplex(
    id: string,
    body: PropertiesServiceSetDraftResidentialComplexBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSetDraftResidentialComplex(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: separate from UpdateResidentialComplex because the rate is the base of every reward in a deal and is edited by a narrower circle — gated on properties:manage_commission (DEV-1873, ADR-0042). A project update leaves the rate untouched.
   * @summary Sets the commission the developer pays VINPROP for this project, together with any free-form terms.
   * @param {string} id
   * @param {PropertiesServiceSetResidentialComplexCommissionBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSetResidentialComplexCommission(
    id: string,
    body: PropertiesServiceSetResidentialComplexCommissionBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSetResidentialComplexCommission(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: separate from UpdateResidentialComplex, which replaces the whole card — the project form and the Drive import would otherwise wipe the badge. Gated on properties:update (DEV-2299).
   * @summary Sets or clears the day sales of a project open. While set, the public site shows a \"sales start\" badge with that date.
   * @param {string} id
   * @param {PropertiesServiceSetResidentialComplexSalesStartBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceSetResidentialComplexSalesStart(
    id: string,
    body: PropertiesServiceSetResidentialComplexSalesStartBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceSetResidentialComplexSalesStart(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Updates a city: names, slug, coordinates and landing page texts.
   * @param {string} id
   * @param {PropertiesServiceUpdateCityBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateCity(
    id: string,
    body: PropertiesServiceUpdateCityBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateCity(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Replaces developer details. Fields left empty are cleared, not kept.
   * @param {PropertiesUpdateDeveloperRequest} body New details of an existing developer. Every field is replaced, so send the full state rather than a patch.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateDeveloper(
    body: PropertiesUpdateDeveloperRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateDeveloper(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Saves a single edited row of a draft. Granular on purpose: reviewers edit rows one at a time, and saving the whole draft would make them race each other.
   * @param {string} id
   * @param {string} rowId
   * @param {PropertiesServiceUpdateDraftRowBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateDraftRow(
    id: string,
    rowId: string,
    body: PropertiesServiceUpdateDraftRowBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateDraftRow(id, rowId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Replaces the details of a standalone listing.
   * @param {PropertiesUpdateObjectRequest} body New details of an existing listing. Every field is replaced.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateObject(
    body: PropertiesUpdateObjectRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateObject(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Repeated fields are replaced wholesale: an empty list clears the previous contents rather than leaving them untouched.
   * @summary Replaces the details of a residential complex.
   * @param {PropertiesUpdateResidentialComplexRequest} body New details of an existing residential complex.  The whole record is replaced: repeated fields and translations sent empty are cleared, not preserved. buf:lint:ignore FIELD_NO_DELETE
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateResidentialComplex(
    body: PropertiesUpdateResidentialComplexRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateResidentialComplex(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Internal note: gated on properties:update (DEV-1003).
   * @summary Opens or closes a single project for real estate agents, without touching its public visibility.
   * @param {string} id
   * @param {PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateResidentialComplexAgentsAvailability(
    id: string,
    body: PropertiesServiceUpdateResidentialComplexAgentsAvailabilityBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateResidentialComplexAgentsAvailability(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Renames a block or changes its floor count.
   * @param {string} id
   * @param {PropertiesServiceUpdateResidentialComplexBlockBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateResidentialComplexBlock(
    id: string,
    body: PropertiesServiceUpdateResidentialComplexBlockBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateResidentialComplexBlock(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Updates a single unit: price, area, layout or sale status.
   * @param {string} id
   * @param {PropertiesServiceUpdateUnitBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PropertiesServiceApi
   */
  public propertiesServiceUpdateUnit(
    id: string,
    body: PropertiesServiceUpdateUnitBody,
    options?: RawAxiosRequestConfig,
  ) {
    return PropertiesServiceApiFp(this.configuration)
      .propertiesServiceUpdateUnit(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const PropertiesServiceListImportDraftsStatusEnum = {
  Invalid: 'UNIT_IMPORT_DRAFT_STATUS_INVALID',
  InProgress: 'UNIT_IMPORT_DRAFT_STATUS_IN_PROGRESS',
  Applied: 'UNIT_IMPORT_DRAFT_STATUS_APPLIED',
  Discarded: 'UNIT_IMPORT_DRAFT_STATUS_DISCARDED',
} as const
export type PropertiesServiceListImportDraftsStatusEnum =
  (typeof PropertiesServiceListImportDraftsStatusEnum)[keyof typeof PropertiesServiceListImportDraftsStatusEnum]
/**
 * @export
 */
export const PropertiesServiceListUnitsFilterStatusEnum = {
  Invalid: 'UNIT_STATUS_INVALID',
  Available: 'UNIT_STATUS_AVAILABLE',
  Reserved: 'UNIT_STATUS_RESERVED',
  Sold: 'UNIT_STATUS_SOLD',
} as const
export type PropertiesServiceListUnitsFilterStatusEnum =
  (typeof PropertiesServiceListUnitsFilterStatusEnum)[keyof typeof PropertiesServiceListUnitsFilterStatusEnum]
/**
 * @export
 */
export const PropertiesServiceListUnitsFilterObjectTypeEnum = {
  Invalid: 'OBJECT_TYPE_INVALID',
  Villa: 'OBJECT_TYPE_VILLA',
  Condotel: 'OBJECT_TYPE_CONDOTEL',
  Shophouse: 'OBJECT_TYPE_SHOPHOUSE',
  Apartment: 'OBJECT_TYPE_APARTMENT',
  Studio: 'OBJECT_TYPE_STUDIO',
  Penthouse: 'OBJECT_TYPE_PENTHOUSE',
  Duplex: 'OBJECT_TYPE_DUPLEX',
} as const
export type PropertiesServiceListUnitsFilterObjectTypeEnum =
  (typeof PropertiesServiceListUnitsFilterObjectTypeEnum)[keyof typeof PropertiesServiceListUnitsFilterObjectTypeEnum]
